/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Beginner_0_HeadingInputs */

const en_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photo everyone learned from`)
};

const es_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La foto de la que todos aprendieron`)
};

const de_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Foto, von dem jeder gelernt hat`)
};

const zh_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人人都学过的那张照片`)
};

const ar_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصورة التي تعلّم منها الجميع`)
};

const fr_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La photo dont tout le monde a appris`)
};

const vi_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tấm ảnh mọi người học từ đó`)
};

const sw_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picha ambayo kila mtu alijifunzia`)
};

const th_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพถ่ายที่ทุกคนเรียนรู้กันมา`)
};

const bs_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografija od koje su svi učili`)
};

const ja_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰もが手本にした一枚の写真`)
};

const ko_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두가 따라 배운 한 장의 사진`)
};

const pt_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foto com que todo mundo aprendeu`)
};

const it_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La foto su cui tutti hanno imparato`)
};

const sv_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotot som alla lärde sig av`)
};

const nl_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De foto waar iedereen van leerde`)
};

const da_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billedet, alle lærte af`)
};

const nb_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildet alle lærte av`)
};

const fi_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuva, josta kaikki oppivat`)
};

const pl_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdjęcie, na którym uczyli się wszyscy`)
};

const ru_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фотография, по которой учились все`)
};

const tr_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herkesin örnek aldığı fotoğraf`)
};

const hi_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह तस्वीर जिससे सबने सीखा`)
};

const id_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto yang menjadi acuan semua orang`)
};

const ms_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambar yang menjadi rujukan semua orang`)
};

const cs_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie, podle které se učili všichni`)
};

const el_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η φωτογραφία από την οποία έμαθαν όλοι`)
};

const he_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התמונה שכולם למדו ממנה`)
};

const af_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die foto waaruit almal geleer het`)
};

const hu_method_content_step_03_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fotó, amelyből mindenki tanult`)
};

/**
* | output |
* | --- |
* | "The photo everyone learned from" |
*
* @param {Method_Content_Step_03_Detail_Beginner_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_beginner_0_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Beginner_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Beginner_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_beginner_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_beginner_0_heading(inputs)
	return en_method_content_step_03_detail_beginner_0_heading(inputs)
});